import axios from 'axios';
import { clearStoragePreservingLanguage } from '../shared/i18n';

const BACKEND_URL =
  (process.env.REACT_APP_BACKEND_URL || '').trim() || 'http://localhost:3334';

const api = axios.create({
  baseURL: BACKEND_URL,
});

api.interceptors.request.use((config) => {
  const tenant =
    sessionStorage.getItem('@Sigeclin:clinic') ||
    sessionStorage.getItem('@Sigeclin:patientTenant');

  if (tenant) {
    config.headers['x-tenant-id'] = tenant;
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      clearStoragePreservingLanguage();

      if (window.location.pathname !== '/') {
        window.location.pathname = '/';
      }
    }

    const currentPath = window.location.pathname;
    const isClientsRoute = /^\/clients(\/|$)/i.test(currentPath);
    const isDashboardRoute = currentPath === '/dashboard';
    const isAddressesRoute = /^\/addresses(\/|$)/i.test(currentPath);
    const canBypass403Redirect =
      isClientsRoute || isDashboardRoute || isAddressesRoute;

    if (
      error?.response?.status === 403 &&
      currentPath !== '/access-denied' &&
      !canBypass403Redirect
    ) {
      window.location.pathname = '/access-denied';
    }

    return Promise.reject(error);
  },
);

export default api;
